import { render, staticRenderFns } from "./CreatorRequestUpload.vue?vue&type=template&id=5fd272f3&"
import script from "./CreatorRequestUpload.vue?vue&type=script&lang=js&"
export * from "./CreatorRequestUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports